export const BRAND_NAME = 'CotaJá';
export const LOGO_SRC = '/assets/images/cotaja-logo.png';
export const SYMBOL_SRC = '/assets/images/cotaja-logo.png';
